module.exports = __webpack_public_path__ + "img/storage-1.ed843d4e.jpg";